import * as Yup from 'yup';
import { YupId } from '../form/schema';

export const nurseRequestSchema = Yup.object().shape({
    agencyId: YupId().required('Pflichtfeld'),
    careNeedId: YupId().required('Pflichtfeld'),
});
